import { Module } from 'vuex'
import { mutations } from './mutations'
import { actions } from './actions'
import { getters } from './getters'

export const module: Module<any, any> = {
  namespaced: true,
  mutations,
  actions,
  getters,
}
